import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { HandHeart, HelpingHand, Heart } from "lucide-react";

export default function ChooseRole() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const pick = async (role) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/role", { role });
      login(data.token, data.user);
      toast.success("Welcome to Kindred!");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const opt = (val, Icon, title, desc, cls) => (
    <button type="button" disabled={loading} data-testid={`choose-role-${val}`} onClick={() => pick(val)}
      className={`flex-1 text-left p-6 rounded-2xl border-2 border-[#E2D9CE] bg-white hover:border-[#D96B43] hover:shadow-md transition-all disabled:opacity-60 ${cls}`}>
      <Icon className="w-10 h-10 mb-3 text-[#D96B43]" />
      <p className="text-xl font-semibold text-slate-900">{title}</p>
      <p className="text-slate-600 mt-1">{desc}</p>
    </button>
  );

  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <div className="text-center mb-8">
        <span className="w-14 h-14 rounded-2xl bg-[#D96B43] inline-flex items-center justify-center shadow-sm">
          <Heart className="w-7 h-7 text-white" fill="white" />
        </span>
        <h1 className="text-3xl font-display font-bold text-slate-900 mt-4">Hello, {user?.name?.split(" ")[0]}!</h1>
        <p className="text-lg text-slate-600 mt-2">One last step — how would you like to use Kindred?</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4">
        {opt("seeker", HelpingHand, "I need help", "Request errands, rides to the doctor, companionship & care.")}
        {opt("helper", HandHeart, "I want to help", "Offer paid or voluntary help to neighbours nearby.")}
      </div>
    </div>
  );
}
